import React from "react";
import { Title, Meta as HeadMeta, Link as HeadLink } from "react-head";
import { useLocation } from "react-router-dom";
import SEOData from "./SEOData";

const Meta = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const seo = SEOData[currentPath] || SEOData["/"];
  const fullURL = `https://www.infodeltasys.com${currentPath}`;

  const ogImage = seo.ogImage
    ? `https://www.infodeltasys.com${seo.ogImage}`
    : `https://www.infodeltasys.com/og-image.png`;

  return (
    <>
      <Title>{seo.title}</Title>

      {/* Basic SEO */}
      <HeadMeta name="description" content={seo.description} />
      <HeadMeta name="robots" content={seo.robots || "index, follow"} />
      <HeadMeta name="author" content="Infodeltasys Software Solution Pvt. Ltd." />
      <HeadLink rel="canonical" href={fullURL} />

      {/* Open Graph */}
      <HeadMeta property="og:title" content={seo.title} />
      <HeadMeta property="og:description" content={seo.description} />
      <HeadMeta property="og:type" content="website" />
      <HeadMeta property="og:url" content={fullURL} />
      <HeadMeta property="og:image" content={ogImage} />

      {/* Twitter */}
      <HeadMeta name="twitter:card" content="summary_large_image" />
      <HeadMeta name="twitter:title" content={seo.title} />
      <HeadMeta name="twitter:description" content={seo.description} />
      <HeadMeta name="twitter:image" content={ogImage} />
    </>
  );
};

export default Meta;
